//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IConfigurationClient {
    get( cancelToken?: CancelToken): Promise<FrontendSettings>;
    jsSettings( cancelToken?: CancelToken): Promise<FileResponse>;
    featureFlags(module?: ModuleName | null | undefined, modules?: ModuleName2 | null | undefined,  cancelToken?: CancelToken): Promise<{ [key in keyof typeof FeatureFlagName]?: boolean; }>;
}

export class ConfigurationClient implements IConfigurationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    get( cancelToken?: CancelToken): Promise<FrontendSettings> {
        let url_ = this.baseUrl + "/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<FrontendSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FrontendSettings.fromJS(resultData200);
            return Promise.resolve<FrontendSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FrontendSettings>(null as any);
    }

    jsSettings( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/configuration.js";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJsSettings(_response);
        });
    }

    protected processJsSettings(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] as string }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    featureFlags(module?: ModuleName | null | undefined, modules?: ModuleName2 | null | undefined, cancelToken?: CancelToken): Promise<{ [key in keyof typeof FeatureFlagName]?: boolean; }> {
        let url_ = this.baseUrl + "/configuration/feature-flags?";
        if (module !== undefined && module !== null)
            url_ += "Module=" + encodeURIComponent("" + module) + "&";
        if (modules !== undefined && modules !== null)
            url_ += "Modules=" + encodeURIComponent("" + modules) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFeatureFlags(_response);
        });
    }

    protected processFeatureFlags(response: AxiosResponse): Promise<{ [key in keyof typeof FeatureFlagName]?: boolean; }> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<{ [key in keyof typeof FeatureFlagName]?: boolean; }>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ValidationErrorResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<{ [key in keyof typeof FeatureFlagName]?: boolean; }>(null as any);
    }
}

// >> Types start 

export class FrontendSettings implements IFrontendSettings {
    sso?: FrontendSsoSettings | undefined;
    api?: FrontendApiSettings | undefined;
    app?: FrontendAppSettings | undefined;

    constructor(data?: IFrontendSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sso = _data["sso"] ? FrontendSsoSettings.fromJS(_data["sso"]) : undefined as any;
            this.api = _data["api"] ? FrontendApiSettings.fromJS(_data["api"]) : undefined as any;
            this.app = _data["app"] ? FrontendAppSettings.fromJS(_data["app"]) : undefined as any;
        }
    }

    static fromJS(data: any): FrontendSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sso"] = this.sso ? this.sso.toJSON() : undefined as any;
        data["api"] = this.api ? this.api.toJSON() : undefined as any;
        data["app"] = this.app ? this.app.toJSON() : undefined as any;
        return data;
    }
}

export interface IFrontendSettings {
    sso?: FrontendSsoSettings | undefined;
    api?: FrontendApiSettings | undefined;
    app?: FrontendAppSettings | undefined;
}

export class FrontendSsoSettings implements IFrontendSsoSettings {
    authority?: string | undefined;
    clientId?: string | undefined;
    logoutTimeInMinutes?: number;
    loginTimeoutInMinutes?: number;
    scopes?: string | undefined;
    clients?: { [key: string]: ClientSettings; } | undefined;

    constructor(data?: IFrontendSsoSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authority = _data["authority"];
            this.clientId = _data["clientId"];
            this.logoutTimeInMinutes = _data["logoutTimeInMinutes"];
            this.loginTimeoutInMinutes = _data["loginTimeoutInMinutes"];
            this.scopes = _data["scopes"];
            if (_data["clients"]) {
                this.clients = {} as any;
                for (let key in _data["clients"]) {
                    if (_data["clients"].hasOwnProperty(key))
                        (this.clients as any)![key] = _data["clients"][key] ? ClientSettings.fromJS(_data["clients"][key]) : new ClientSettings();
                }
            }
        }
    }

    static fromJS(data: any): FrontendSsoSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendSsoSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authority"] = this.authority;
        data["clientId"] = this.clientId;
        data["logoutTimeInMinutes"] = this.logoutTimeInMinutes;
        data["loginTimeoutInMinutes"] = this.loginTimeoutInMinutes;
        data["scopes"] = this.scopes;
        if (this.clients) {
            data["clients"] = {};
            for (let key in this.clients) {
                if (this.clients.hasOwnProperty(key))
                    (data["clients"] as any)[key] = this.clients[key] ? this.clients[key].toJSON() : undefined as any;
            }
        }
        return data;
    }
}

export interface IFrontendSsoSettings {
    authority?: string | undefined;
    clientId?: string | undefined;
    logoutTimeInMinutes?: number;
    loginTimeoutInMinutes?: number;
    scopes?: string | undefined;
    clients?: { [key: string]: ClientSettings; } | undefined;
}

export class ClientSettings implements IClientSettings {
    id?: string | undefined;
    scopes?: string | undefined;
    audience?: string | undefined;
    type?: string | undefined;

    constructor(data?: IClientSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scopes = _data["scopes"];
            this.audience = _data["audience"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ClientSettings {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scopes"] = this.scopes;
        data["audience"] = this.audience;
        data["type"] = this.type;
        return data;
    }
}

export interface IClientSettings {
    id?: string | undefined;
    scopes?: string | undefined;
    audience?: string | undefined;
    type?: string | undefined;
}

export class FrontendApiSettings implements IFrontendApiSettings {
    commonApiUrl?: string | undefined;
    spaApiUrl?: string | undefined;
    eDeclarationsApiUrl?: string | undefined;
    eDeclarationsTestsApiUrl?: string | undefined;
    appointmentsApiUrl?: string | undefined;
    globalSearchApiUrl?: string | undefined;

    constructor(data?: IFrontendApiSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commonApiUrl = _data["commonApiUrl"];
            this.spaApiUrl = _data["spaApiUrl"];
            this.eDeclarationsApiUrl = _data["eDeclarationsApiUrl"];
            this.eDeclarationsTestsApiUrl = _data["eDeclarationsTestsApiUrl"];
            this.appointmentsApiUrl = _data["appointmentsApiUrl"];
            this.globalSearchApiUrl = _data["globalSearchApiUrl"];
        }
    }

    static fromJS(data: any): FrontendApiSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendApiSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commonApiUrl"] = this.commonApiUrl;
        data["spaApiUrl"] = this.spaApiUrl;
        data["eDeclarationsApiUrl"] = this.eDeclarationsApiUrl;
        data["eDeclarationsTestsApiUrl"] = this.eDeclarationsTestsApiUrl;
        data["appointmentsApiUrl"] = this.appointmentsApiUrl;
        data["globalSearchApiUrl"] = this.globalSearchApiUrl;
        return data;
    }
}

export interface IFrontendApiSettings {
    commonApiUrl?: string | undefined;
    spaApiUrl?: string | undefined;
    eDeclarationsApiUrl?: string | undefined;
    eDeclarationsTestsApiUrl?: string | undefined;
    appointmentsApiUrl?: string | undefined;
    globalSearchApiUrl?: string | undefined;
}

export class FrontendAppSettings implements IFrontendAppSettings {
    maxAuditLogsCount?: number;
    appInsightsInstrumentationKey?: string | undefined;
    obfuscatePIIData?: boolean;
    buildNo?: string | undefined;
    environment?: string | undefined;
    featureFlag?: string | undefined;
    featureFlagOrganization?: string | undefined;
    ePitUrl?: string | undefined;
    giifUrl?: string | undefined;
    surveyUrl?: string | undefined;
    surveyIsEnabled?: boolean;
    contactUrl?: string | undefined;
    servicesUrl?: string | undefined;
    downloadAppFromGoogleStoreUrl?: string | undefined;
    downloadAppFromAppleStoreUrl?: string | undefined;
    enableAuthorizationServiceErrorTracking?: boolean;
    blockingApplicationUntil?: string | undefined;
    taxReturn?: TaxReturnSettings | undefined;
    documentCountInterval?: number;
    chatbotBaseUrl?: string | undefined;
    telepin?: TelepinSettings | undefined;
    epitNotification?: ManagementEpitNotificationConfiguration | undefined;
    banner?: BannerSettings | undefined;

    constructor(data?: IFrontendAppSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxAuditLogsCount = _data["maxAuditLogsCount"];
            this.appInsightsInstrumentationKey = _data["appInsightsInstrumentationKey"];
            this.obfuscatePIIData = _data["obfuscatePIIData"];
            this.buildNo = _data["buildNo"];
            this.environment = _data["environment"];
            this.featureFlag = _data["featureFlag"];
            this.featureFlagOrganization = _data["featureFlagOrganization"];
            this.ePitUrl = _data["ePitUrl"];
            this.giifUrl = _data["giifUrl"];
            this.surveyUrl = _data["surveyUrl"];
            this.surveyIsEnabled = _data["surveyIsEnabled"];
            this.contactUrl = _data["contactUrl"];
            this.servicesUrl = _data["servicesUrl"];
            this.downloadAppFromGoogleStoreUrl = _data["downloadAppFromGoogleStoreUrl"];
            this.downloadAppFromAppleStoreUrl = _data["downloadAppFromAppleStoreUrl"];
            this.enableAuthorizationServiceErrorTracking = _data["enableAuthorizationServiceErrorTracking"];
            this.blockingApplicationUntil = _data["blockingApplicationUntil"];
            this.taxReturn = _data["taxReturn"] ? TaxReturnSettings.fromJS(_data["taxReturn"]) : undefined as any;
            this.documentCountInterval = _data["documentCountInterval"];
            this.chatbotBaseUrl = _data["chatbotBaseUrl"];
            this.telepin = _data["telepin"] ? TelepinSettings.fromJS(_data["telepin"]) : undefined as any;
            this.epitNotification = _data["epitNotification"] ? ManagementEpitNotificationConfiguration.fromJS(_data["epitNotification"]) : undefined as any;
            this.banner = _data["banner"] ? BannerSettings.fromJS(_data["banner"]) : undefined as any;
        }
    }

    static fromJS(data: any): FrontendAppSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FrontendAppSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxAuditLogsCount"] = this.maxAuditLogsCount;
        data["appInsightsInstrumentationKey"] = this.appInsightsInstrumentationKey;
        data["obfuscatePIIData"] = this.obfuscatePIIData;
        data["buildNo"] = this.buildNo;
        data["environment"] = this.environment;
        data["featureFlag"] = this.featureFlag;
        data["featureFlagOrganization"] = this.featureFlagOrganization;
        data["ePitUrl"] = this.ePitUrl;
        data["giifUrl"] = this.giifUrl;
        data["surveyUrl"] = this.surveyUrl;
        data["surveyIsEnabled"] = this.surveyIsEnabled;
        data["contactUrl"] = this.contactUrl;
        data["servicesUrl"] = this.servicesUrl;
        data["downloadAppFromGoogleStoreUrl"] = this.downloadAppFromGoogleStoreUrl;
        data["downloadAppFromAppleStoreUrl"] = this.downloadAppFromAppleStoreUrl;
        data["enableAuthorizationServiceErrorTracking"] = this.enableAuthorizationServiceErrorTracking;
        data["blockingApplicationUntil"] = this.blockingApplicationUntil;
        data["taxReturn"] = this.taxReturn ? this.taxReturn.toJSON() : undefined as any;
        data["documentCountInterval"] = this.documentCountInterval;
        data["chatbotBaseUrl"] = this.chatbotBaseUrl;
        data["telepin"] = this.telepin ? this.telepin.toJSON() : undefined as any;
        data["epitNotification"] = this.epitNotification ? this.epitNotification.toJSON() : undefined as any;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined as any;
        return data;
    }
}

export interface IFrontendAppSettings {
    maxAuditLogsCount?: number;
    appInsightsInstrumentationKey?: string | undefined;
    obfuscatePIIData?: boolean;
    buildNo?: string | undefined;
    environment?: string | undefined;
    featureFlag?: string | undefined;
    featureFlagOrganization?: string | undefined;
    ePitUrl?: string | undefined;
    giifUrl?: string | undefined;
    surveyUrl?: string | undefined;
    surveyIsEnabled?: boolean;
    contactUrl?: string | undefined;
    servicesUrl?: string | undefined;
    downloadAppFromGoogleStoreUrl?: string | undefined;
    downloadAppFromAppleStoreUrl?: string | undefined;
    enableAuthorizationServiceErrorTracking?: boolean;
    blockingApplicationUntil?: string | undefined;
    taxReturn?: TaxReturnSettings | undefined;
    documentCountInterval?: number;
    chatbotBaseUrl?: string | undefined;
    telepin?: TelepinSettings | undefined;
    epitNotification?: ManagementEpitNotificationConfiguration | undefined;
    banner?: BannerSettings | undefined;
}

export class TaxReturnSettings implements ITaxReturnSettings {
    defaultPeriod?: TaxReturnPeriod | undefined;
    customPeriods?: TaxReturnPeriod[] | undefined;

    constructor(data?: ITaxReturnSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultPeriod = _data["defaultPeriod"] ? TaxReturnPeriod.fromJS(_data["defaultPeriod"]) : undefined as any;
            if (Array.isArray(_data["customPeriods"])) {
                this.customPeriods = [] as any;
                for (let item of _data["customPeriods"])
                    this.customPeriods!.push(TaxReturnPeriod.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TaxReturnSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReturnSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultPeriod"] = this.defaultPeriod ? this.defaultPeriod.toJSON() : undefined as any;
        if (Array.isArray(this.customPeriods)) {
            data["customPeriods"] = [];
            for (let item of this.customPeriods)
                data["customPeriods"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITaxReturnSettings {
    defaultPeriod?: TaxReturnPeriod | undefined;
    customPeriods?: TaxReturnPeriod[] | undefined;
}

export class TaxReturnPeriod implements ITaxReturnPeriod {
    isActive?: boolean;
    year?: number | undefined;
    fromMonth?: number;
    fromDay?: number;
    toMonth?: number;
    toDay?: number;

    constructor(data?: ITaxReturnPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isActive = _data["isActive"];
            this.year = _data["year"];
            this.fromMonth = _data["fromMonth"];
            this.fromDay = _data["fromDay"];
            this.toMonth = _data["toMonth"];
            this.toDay = _data["toDay"];
        }
    }

    static fromJS(data: any): TaxReturnPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new TaxReturnPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isActive"] = this.isActive;
        data["year"] = this.year;
        data["fromMonth"] = this.fromMonth;
        data["fromDay"] = this.fromDay;
        data["toMonth"] = this.toMonth;
        data["toDay"] = this.toDay;
        return data;
    }
}

export interface ITaxReturnPeriod {
    isActive?: boolean;
    year?: number | undefined;
    fromMonth?: number;
    fromDay?: number;
    toMonth?: number;
    toDay?: number;
}

export class TelepinSettings implements ITelepinSettings {
    messageIsActive?: boolean;
    showMessageToDate?: string | undefined;

    constructor(data?: ITelepinSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageIsActive = _data["messageIsActive"];
            this.showMessageToDate = _data["showMessageToDate"];
        }
    }

    static fromJS(data: any): TelepinSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TelepinSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageIsActive"] = this.messageIsActive;
        data["showMessageToDate"] = this.showMessageToDate;
        return data;
    }
}

export interface ITelepinSettings {
    messageIsActive?: boolean;
    showMessageToDate?: string | undefined;
}

export class ManagementEpitNotificationConfigurationBase implements IManagementEpitNotificationConfigurationBase {
    messageMode?: string;
    disabledEpitToDate?: string | undefined;
    disabledEpitFromDate?: string | undefined;
    sid?: string;

    constructor(data?: IManagementEpitNotificationConfigurationBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageMode = _data["messageMode"];
            this.disabledEpitToDate = _data["disabledEpitToDate"];
            this.disabledEpitFromDate = _data["disabledEpitFromDate"];
            this.sid = _data["sid"];
        }
    }

    static fromJS(data: any): ManagementEpitNotificationConfigurationBase {
        data = typeof data === 'object' ? data : {};
        let result = new ManagementEpitNotificationConfigurationBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageMode"] = this.messageMode;
        data["disabledEpitToDate"] = this.disabledEpitToDate;
        data["disabledEpitFromDate"] = this.disabledEpitFromDate;
        data["sid"] = this.sid;
        return data;
    }
}

export interface IManagementEpitNotificationConfigurationBase {
    messageMode?: string;
    disabledEpitToDate?: string | undefined;
    disabledEpitFromDate?: string | undefined;
    sid?: string;
}

export class ManagementEpitNotificationConfiguration extends ManagementEpitNotificationConfigurationBase implements IManagementEpitNotificationConfiguration {
    isBlockedEpit?: boolean;
    type?: string;

    constructor(data?: IManagementEpitNotificationConfiguration) {
        super(data);
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.isBlockedEpit = _data["isBlockedEpit"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ManagementEpitNotificationConfiguration {
        data = typeof data === 'object' ? data : {};
        let result = new ManagementEpitNotificationConfiguration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBlockedEpit"] = this.isBlockedEpit;
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }
}

export interface IManagementEpitNotificationConfiguration extends IManagementEpitNotificationConfigurationBase {
    isBlockedEpit?: boolean;
    type?: string;
}

export class BannerSettings implements IBannerSettings {
    user?: BannerTargetSettings | undefined;
    organization?: BannerTargetSettings | undefined;

    constructor(data?: IBannerSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? BannerTargetSettings.fromJS(_data["user"]) : undefined as any;
            this.organization = _data["organization"] ? BannerTargetSettings.fromJS(_data["organization"]) : undefined as any;
        }
    }

    static fromJS(data: any): BannerSettings {
        data = typeof data === 'object' ? data : {};
        let result = new BannerSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["organization"] = this.organization ? this.organization.toJSON() : undefined as any;
        return data;
    }
}

export interface IBannerSettings {
    user?: BannerTargetSettings | undefined;
    organization?: BannerTargetSettings | undefined;
}

export class BannerTargetSettings implements IBannerTargetSettings {
    sidDesktop?: string | undefined;
    sidMobile?: string | undefined;

    constructor(data?: IBannerTargetSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sidDesktop = _data["sidDesktop"];
            this.sidMobile = _data["sidMobile"];
        }
    }

    static fromJS(data: any): BannerTargetSettings {
        data = typeof data === 'object' ? data : {};
        let result = new BannerTargetSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sidDesktop"] = this.sidDesktop;
        data["sidMobile"] = this.sidMobile;
        return data;
    }
}

export interface IBannerTargetSettings {
    sidDesktop?: string | undefined;
    sidMobile?: string | undefined;
}

export enum FeatureFlagName {
    User_Chatbot = 0,
    User_Settlements_Stage_Two = 1,
    User_E_Declarations_Modal = 2,
    User_DeclarationHistoryExport = 3,
    User_Hotjar = 4,
    User_Notary_Old_Schema_Validation = 5,
    User_TaxDues = 6,
    User_TaxPayerReport_TaxationForm_v2 = 7,
    User_New_ZasW = 8,
    User_New_ZasDF = 9,
    User_New_ZasDFU = 10,
    User_TicketExport = 11,
    User_Tickets_Quick_Payment = 12,
    User_Notary_Acts_Export = 13,
    User_Seizures = 14,
    User_Seizures_Export = 15,
    Organization_Payments = 16,
    Organization_DeclarationHistoryPreviewSimplified = 17,
    Organization_Settlements_Stage_Two = 18,
    Organization_DeclarationHistoryExport = 19,
    Organization_E_Declarations_Modal = 20,
    Organization_New_ZasW = 21,
    Organization_TaxDues = 22,
    Organization_Seizures = 23,
    Organization_Seizures_Export = 24,
    User_E_Declarations_Payment_Is_Enabled = 25,
    SaveAuditCorrelationLogs = 26,
    UnsupportedBrowser = 27,
    EDeclarations_FormInModalEnabled = 28,
    MobileApp = 29,
    User_CardPayment = 30,
    User_Documents_Submitted_Export = 31,
    Organization_Documents_Submitted_Export = 32,
    User_Delivery_Export = 33,
    Organization_Delivery_Export = 34,
    User_Mobile_Check_Session = 35,
    User_Appointments = 36,
    EDeclarations_RefactoredWizardEnabled = 37,
    User_FileDownloadNewMethodEnabled = 38,
    Organization_FileDownloadNewMethodEnabled = 39,
    User_PenaltyNoticesLabelsEnabled = 40,
    User_FiscalTicketsEnabled = 41,
    Organization_FiscalTicketsEnabled = 42,
    EDeclarations_FactoryEnabled = 43,
    User_FiscalTicketsPayments = 44,
    Organization_FiscalTicketsPayments = 45,
    User_WisApplicationBasedOnGeneralForm = 46,
    Organization_WisApplicationBasedOnGeneralForm = 47,
    PolishTimeZoneAlertEnabled = 48,
    AuditLogHistoryInSettingsGroup = 49,
    User_Retry_Payment_Modal = 50,
    User_Global_Search_Enabled = 51,
    Organization_Global_Search_Enabled = 52,
    Organization_Declaration_Submitted_Export = 53,
    User_NotaryDeeds_Export = 54,
    User_Declaration_Submitted_Export = 55,
    User_YourAccountAndPermissionsForOtherAccountsEnabled = 56,
    Organization_PermissionsForOrganizationAccountEnabled = 57,
    User_YourAccountAndPermissionsForOtherAccountsEnabled_Mobile = 58,
    Organization_PermissionsForOrganizationAccountEnabled_Mobile = 59,
    DelegationUser = 60,
    Mobile_DelegationUser = 61,
    DelegationOrganization = 62,
    Mobile_DelegationOrganization = 63,
    ForeignerUser_CountryNodeCrossBorderChatbot = 64,
    CountryNodeCrossBorder = 65,
    ConfirmNotificationChannelModal = 66,
    EDeclarations_RefactoredSMEWizardEnabled = 67,
    User_WisAppealOrComplaint = 68,
    User_PowerOfAttorneyLegislation = 69,
    Organization_PowerOfAttorneyLegislation = 70,
    Organization_WisAppealOrComplaint = 71,
    User_OtherAccountsNewTable = 72,
    DarkModeEus = 73,
    FiscalModuleEnabled = 74,
    User_WalletPayment = 75,
}

export class ValidationErrorResult implements IValidationErrorResult {
    errors?: { [key: string]: string[]; } | undefined;
    status?: number;
    traceId?: string | undefined;
    title?: string | undefined;
    subStatus?: string | undefined;

    constructor(data?: IValidationErrorResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property) && this.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
            this.status = _data["status"];
            this.traceId = _data["traceId"];
            this.title = _data["title"];
            this.subStatus = _data["subStatus"];
        }
    }

    static fromJS(data: any): ValidationErrorResult {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationErrorResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = (this.errors as any)[key];
            }
        }
        data["status"] = this.status;
        data["traceId"] = this.traceId;
        data["title"] = this.title;
        data["subStatus"] = this.subStatus;
        return data;
    }
}

export interface IValidationErrorResult {
    errors?: { [key: string]: string[]; } | undefined;
    status?: number;
    traceId?: string | undefined;
    title?: string | undefined;
    subStatus?: string | undefined;
}

export enum ModuleName {
    None = 0,
    Organization = 1,
    User = 2,
    EDeclarations = 3,
    Host = 4,
    IncorrectPerson = 5,
    DelegationUser = 6,
    DelegationOrganization = 7,
    ForeignerUser = 8,
    MobileApp = 9,
}

export enum ModuleName2 {
    None = 0,
    Global = 1,
    Organization = 2,
    User = 4,
    EDeclarations = 8,
    Host = 16,
    IncorrectPerson = 32,
    DelegationUser = 64,
    DelegationOrganization = 128,
    MobileApp = 256,
    ForeignerUser = 512,
}

// << Types end

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}